/**
 * خريطة الصلاحيات للمسارات وعناصر القائمة
 * يستخدم مفاتيح الصلاحيات المرجعة من /api/auth/me
 */

// صلاحيات عرض كل مسار/صفحة
// القيمة null = لا يتطلب صلاحية (أو يُفحص خارجياً)
export const ROUTE_PERMISSIONS = {
  dashboard: 'education.view_statistics',
  profile: 'users.read',
  'edit-profile': 'users.read',
  users: 'users.read',
  students: ['users.read', 'education.view_sessions'],
  competitions: 'competitions.read',
  reports: 'education.view_statistics',
  settings: 'organization.update',
  countries: 'organization.read',
  regions: 'organization.read',
  academies: 'organization.read',
  districts: 'organization.read',
  institutions: 'organization.read',
  departments: 'organization.read',
  'learning-levels': 'education.manage_levels',
  'daily-exercises': ['education.manage_sessions', 'education.view_sessions'],
};

// مسار كل صفحة ضمن /dashboard
export const getRoutePath = (route) => `/dashboard/${route}`;

// التحقق من إمكانية عرض مسار بناءً على الصلاحيات
export const canAccessRoute = (route, hasPermission, hasAnyPermission) => {
  const perm = ROUTE_PERMISSIONS[route];
  if (!perm) return true;
  if (Array.isArray(perm)) return hasAnyPermission(perm);
  return hasPermission(perm);
};
